var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApolloMutation',{attrs:{"mutation":(gql) => _vm.removeItemQuery,"variables":{
    id: _vm.id,
  }},on:{"done":_vm.onDone},scopedSlots:_vm._u([{key:"default",fn:function({ mutate, loading }){return [_c('v-btn',{attrs:{"color":"warning","icon":"","small":"","loading":loading,"disabled":loading},on:{"click":() => {
        _vm.removeLoading = true;
        mutate();
      }}},[_c('ekitabu-icon',{attrs:{"size":"18"}},[_vm._v(" $trash ")])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }